import React from "react";
import { LegalPlaceholder } from "@/components/LegalDocument";

export default function Licences() {
    return (
        <LegalPlaceholder
            title="Licences"
            intro="This page will list the open-source and third-party libraries used to build Pearl - EnergyFlow, along with their respective licences and attributions."
            testid="legal-licences-screen"
        />
    );
}
